module.exports = __webpack_public_path__ + "img/calendar2_b.1a7f4494.svg";